/*<h6 class="text-center text-primary bg-light rounded mt-4 py-3">
    PRIJATELJI PUTOVANJA
</h6>
<div class="row justify-content-center">
    <div class="col-auto">
        <img class="lozad" src="https://www.rapsodytravel.rs/images/prijatelji/Nescafe-logo.png" />
    </div>
    <div class="col-auto">
        <img class="lozad" src="https://www.rapsodytravel.rs/images/prijatelji/Triglav_sajt.png" />
    </div>
</div>*/

/*<!-- wp:columns {"className":"d-flex justify-content-center"} -->
<div class="wp-block-columns d-flex justify-content-center"><!-- wp:column {"width":"25%"} -->
<div class="wp-block-column" style="flex-basis:25%"><!-- wp:paragraph -->
<p>test</p>
<!-- /wp:paragraph --></div>
<!-- /wp:column -->

<!-- wp:column {"width":"25%"} -->
<div class="wp-block-column" style="flex-basis:25%"><!-- wp:paragraph -->
<p>test2</p>
<!-- /wp:paragraph --></div>
<!-- /wp:column --></div>
<!-- /wp:columns -->*/

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        InnerBlocks,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        TextControl,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/partner-section', {
        // built-in attributes
        title: 'Partner Section',
        description: 'Custom Partner Section',
        icon: '',
        category: 'custom-content',
        example: {},

        // custom attributes
        attributes: {
            title: {
                type: 'string',
                default: 'PRIJATELJI PUTOVANJA',
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                title
            } = attributes;

            // custom functions
            function onTitleChange (title) {
                setAttributes({title: title});
            };

            const MY_TEMPLATE = [
                [ 'core/columns', { className: 'd-flex justify-content-center' },
                    [
                        [ 'core/column', { width: '20%' } ], 
                        [ 'core/column', { width: '20%' } ] 
                    ]
                ],
            ];


            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <p><strong>Title:</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />

                    </PanelBody>
                </InspectorControls>
                ,
                <div class="partner-section">
                    <RichText
                        key="editable"
                        tagName="p" 
                        className="h6 text-center text-primary bg-light rounded mt-4 py-3" 
                        placeholder="PRIJATELJI PUTOVANJA"
                        value={ title } 
                        onChange={ onTitleChange } />

                    <InnerBlocks template={ MY_TEMPLATE } />
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                title
            } = attributes;

            return (
                <div class="partner-section">
                    <RichText.Content
                        tagName="p" 
                        className="h6 text-center text-primary bg-light rounded mt-4 py-3" 
                        value={ title } />

                    <InnerBlocks.Content />
                </div>
            );
        },
    });
}